import AppService from 'App/legacy/AppService';
/**
 * Provide phone config attributes for call from web
 * @returns {object} - phone config attributes
 */
const CallFromWebConfigHelper = (name, type, phone, href) => {
	const phoneIntegration = AppService.getPhoneIntegration();
	const hasCallFromWeb = AppService.getSelf().userParams.callFromWeb;
	const defaultHref = `callto:${phone}`;

	return phone && !phoneIntegration && hasCallFromWeb
		? ReactTemplates.TOOLS.upVoice({ name }, type, phone)
		: { href: href || defaultHref };
};

export default CallFromWebConfigHelper;
